import React from 'react';
import { useDispatch, batch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Typography, makeStyles } from '@material-ui/core';
import { routes, baseNumeroEditalContent } from 'src/shared/constants';
import { MessageBox } from 'src/shared/components';
import {
  setQuestionContentPreviewText,
  setQuestionPlaceholder,
  setQuestionTitle,
} from '../redux/quizActions';
import CustomQuiz from './CustomQuiz';
import { useInsured, useProductKey, useProposal, useQuiz } from '../hooks';

const useStyles = makeStyles({
  insuredName: {
    fontSize: 14,
    padding: '5px 8px',
    marginTop: -10,
    marginBottom: -21,
    backgroundColor: '#EEE',
  },
});

const ProposalQuizPage = () => {
  const classes = useStyles();

  const dispatch = useDispatch();
  const { productKey } = useProductKey();
  const { activeQuestion, incrementStepper, decrementStepper } = useQuiz();
  const {
    insured,
    insuredForbidden,
    openModalError,
    insuredError,
    ackInsuredError,
    insuredErrorMessage,
    additionalProps,
  } = useInsured();
  const { createProposal } = useProposal();

  const { quoteId } = useParams();

  const nextPage = () => incrementStepper({ actionAfterQuiz: createProposal });
  const previousPage = () =>
    decrementStepper({
      pageBeforQuiz: `${routes[productKey].path}${routes.quote.path}/${quoteId}`,
    });

  const additionalDispatches = (value) => {
    if (activeQuestion.propertyName === 'MODALIDADE_LICITACAO') {
      const propertyName = 'NUMERO_EDITAL';
      let modalidade = '';
      let placeholder = 'XXX/XXXX';
      let title = 'Qual o número e ano do documento?';

      if (value === 'Outro') {
        placeholder = 'Modalidade XXX/XXXX';
        title =
          productKey === 'garantiaBidPublico'
            ? 'Qual a modalidade e número do documento?'
            : 'Qual o nome do documento e número?';
      } else {
        modalidade = value;
        placeholder = 'XXX/XXXX';
      }

      const placeholderPayload = {
        propertyName,
        placeholder,
      };
      const contentPayload = {
        propertyName,
        content:
          value !== 'Outro'
            ? `${baseNumeroEditalContent} ${modalidade} número {{NUMERO_EDITAL}}.`
            : `${baseNumeroEditalContent} ${modalidade} {{NUMERO_EDITAL}}.`,
      };
      const titlePayload = {
        propertyName,
        title,
      };

      batch(() => {
        dispatch(setQuestionPlaceholder(placeholderPayload));
        dispatch(setQuestionContentPreviewText(contentPayload));
        dispatch(setQuestionTitle(titlePayload));
      });
    }
  };

  return (
    <>
      <MessageBox
        opened={openModalError}
        type="error"
        handleClose={ackInsuredError}
        handleSecondary={ackInsuredError}
        labelSecondary="Fechar"
        title="Erro ao validar o CNPJ"
        text={insuredErrorMessage}
      />
      <CustomQuiz
        quizKey="proposal"
        nextPage={nextPage}
        previousPage={previousPage}
        renderInputComplement={() => {
          if (
            activeQuestion.propertyName === 'CNPJ_SEGURADO' &&
            insured.name &&
            !insuredError?.hasError
          ) {
            return <Typography className={classes.insuredName}>{insured.name}</Typography>;
          }
          return null;
        }}
        disableNext={insuredForbidden || insuredError?.hasError}
        additionalProps={additionalProps}
        additionalDispatches={additionalDispatches}
      />
    </>
  );
};

export default ProposalQuizPage;
